import { useStore } from 'effector-react'
import React from 'react'
import { Login } from '~/features/auth/Login'
import { loginFx } from '~/features/auth/Login/model'
import { viewerModel } from '~/entities/viewer'
import { Button } from '~/shared/ui/Buttons'
import { LogoContainer } from '~/shared/ui/LogoContainer'
import { Wrapper } from './styled'

function LoginPage() {
  const authenticated = viewerModel.useAuthenticated()
  const isLoginPending = useStore(loginFx.pending)
  const isLogoutPending = useStore(viewerModel.logoutFx.pending)

  return (
    <>
      {authenticated && !isLoginPending ? (
        <Wrapper>
          <div>Вы уже авторизованы</div>
          <Button
            variant='textLink'
            to='/'
            style={{
              marginTop: '35px',
              marginBottom: '20px',
              textDecoration: 'underline',
            }}
          >
            На главную
          </Button>
          <Button
            loading={isLogoutPending}
            variant='limeFlooded'
            size='large'
            onClick={() => viewerModel.signOut()}
          >
            Выйти
          </Button>
        </Wrapper>
      ) : (
        <LogoContainer title='Авторизация'>
          <Login />
        </LogoContainer>
      )}
    </>
  )
}

export default LoginPage
